import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import "../i18n";

export default function WorkspaceSwitcher({ compact = false }) {
  const { t } = useTranslation();
  const {
    workspaces,
    selectedWorkspace,
    selectedStore,
    switchWorkspace,
    switchStore,
  } = useAuth();

  if (!selectedWorkspace || !selectedStore) return null;

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1}
      sx={{ minWidth: 0, width: compact ? "100%" : "auto" }}
    >
      <Box sx={{ minWidth: compact ? 0 : 170, flex: compact ? 1 : "initial" }}>
        {!compact && (
          <Typography variant="caption" color="text.secondary" sx={{ px: 0.5 }}>
            {t("nav.workspace")}
          </Typography>
        )}
        <FormControl fullWidth size="small">
          <Select
            value={selectedWorkspace.public_id}
            onChange={(event) => switchWorkspace(event.target.value)}
            aria-label={t("nav.selectWorkspace")}
            sx={{ bgcolor: "white", borderRadius: 2.5, fontWeight: 700 }}
          >
            {workspaces.map((workspace) => (
              <MenuItem key={workspace.public_id} value={workspace.public_id}>
                {workspace.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ minWidth: compact ? 0 : 150, flex: compact ? 1 : "initial" }}>
        {!compact && (
          <Typography variant="caption" color="text.secondary" sx={{ px: 0.5 }}>
            {t("nav.store")}
          </Typography>
        )}
        <FormControl fullWidth size="small">
          <Select
            value={selectedStore.public_id}
            onChange={(event) => switchStore(event.target.value)}
            aria-label={t("nav.selectStore")}
            sx={{ bgcolor: "white", borderRadius: 2.5, fontWeight: 700 }}
          >
            {(selectedWorkspace.stores || []).map((store) => (
              <MenuItem key={store.public_id} value={store.public_id}>
                {store.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Stack>
  );
}
